// extracted by mini-css-extract-plugin
export default {"flex":"styles_flex__HXL4V"};